import * as yup from "yup";

export const vendorInformationsSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  code: yup.string().required("Code is required"),
});
